var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchlensreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.649,
    height: 12.649,
    viewBox: "0 0 12.649 12.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(-862.001 -663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_4_",
    "data-name": "search (4)",
    transform: "translate(862.001 663)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M12.572,11.827,8.9,8.152a5.017,5.017,0,1,0-.745.745l3.675,3.675a.264.264,0,0,0,.373,0l.373-.373A.264.264,0,0,0,12.572,11.827ZM5.007,8.96A3.953,3.953,0,1,1,8.96,5.007,3.957,3.957,0,0,1,5.007,8.96Z",
    transform: "translate(0 0)",
    fill: "#004c75"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchlensreview);
export default __webpack_public_path__ + "static/media/Searchlensreview.3b7e2890a9da30e090e06c80c0291ca0.svg";
export { ForwardRef as ReactComponent };